
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import PresenceAvatar from '@webex/react-component-presence-avatar';

import getAvatarProps from './selectors';
import reducers from './reducer';

function mapStateToProps(state, props) {
  const {image, presenceStatus} = getAvatarProps(state, props);

  return Object.assign({}, props, {
    image,
    presenceStatus
  });
}

const ConnectedPresenceAvatar = connect(
  mapStateToProps
)(PresenceAvatar);

PresenceAvatar.propTypes = {
  avatarId: PropTypes.string,
  baseColor: PropTypes.string,
  iconSize: PropTypes.string,
  image: PropTypes.string,
  isSelfAvatar: PropTypes.bool,
  name: PropTypes.string,
  onClick: PropTypes.func,
  presenceStatus: PropTypes.string
};

export default ConnectedPresenceAvatar;

export {reducers};
